import { combineEpics } from 'redux-observable';
import authentication from './Authentication';
import passwordreset from './PasswordReset';
import search from './Search';
import user from './User';
import company from './Company';
import audit from './Audit';

const combinedEpic = combineEpics(
  ...authentication,
  ...passwordreset,
  ...search,
  ...user,
  ...company,
  ...audit
);

export default combinedEpic;
